/**
 * Store de la run en cours (Zustand) — état unique lu par React **et** par Phaser.
 *
 * Le store ne fait aucune règle : toute transition passe par `reduire()` (`reduction.ts`), testée
 * séparément. Les appels réseau restent dans l'écran (`screens/jeu.tsx`) : le store ne connaît ni
 * fetch ni jeton.
 *
 * Le store est **en mémoire uniquement** : aucune sérialisation, donc aucun montant qui survivrait
 * à un rechargement (DECISIONS §7.4 : fermer l'onglet = run perdue).
 */
import { create } from 'zustand';

import { ETAT_RUN_INITIAL, reduire } from './reduction';

import type { ActionRun, EtatRun } from './reduction';

export interface StoreRun extends EtatRun {
  /** Applique une action ; c'est le seul point d'écriture de l'état de run. */
  readonly envoyer: (action: ActionRun) => void;
}

export const useRunStore = create<StoreRun>((set) => ({
  ...ETAT_RUN_INITIAL,
  envoyer: (action) => {
    set((etat) => reduire(etat, action));
  },
}));

/** État courant hors composant React (contrôleurs, diagnostics). */
export function lireEtatRun(): EtatRun {
  return useRunStore.getState();
}

/** Réinitialise le store (démontage de l'écran de jeu, fin de démonstration). */
export function reinitialiserRun(): void {
  useRunStore.getState().envoyer({ type: 'reinitialiser' });
}
